import React from 'react';
import { CheckCircleIcon, PlusCircleIcon } from 'lucide-react';
export function Services() {
  const basicServices = ['Registro de operaciones contables mensuales, a trabajarse por mes vencido', 'Elaboración y control de libros contables (compras, ventas, diario, mayor, balances)', 'Elaboración de estados financieros básicos (Balance General y Estado de Resultados)', 'Conciliaciones bancarias', 'Preparación de declaraciones tributarias', 'Asesoría contable y fiscal básica relacionada con las operaciones de la empresa'];
  const additionalServices = ['Reportería contable y financiera personalizada (solicitada con anticipación)', 'Reportería de requerimientos de auditoría externa o de la SAT', 'Contador o auxiliar contable dedicado físicamente en tu empresa'];
  return <section id="servicios" className="py-20 bg-white dark:bg-gray-900" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="text-center mb-16" data-id="element-267">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-268">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto" data-id="element-269">
            Soluciones contables y fiscales completas para tu empresa
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-270">
          {/* Basic Services */}
          <div className="bg-gradient-to-br from-purple-50 to-white dark:from-gray-800 dark:to-gray-900 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2" data-id="element-271">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-272">
              Servicios Contables Generales
            </h3>
            <ul className="space-y-4" data-id="element-273">
              {basicServices.map((service, index) => <li key={index} className="flex items-start" data-id="element-274">
                  <CheckCircleIcon className="w-6 h-6 text-purple-600 dark:text-purple-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-275" />
                  <span className="text-gray-700 dark:text-gray-300" data-id="element-276">
                    {service}
                  </span>
                </li>)}
            </ul>
            <p className="mt-6 text-sm text-gray-600 dark:text-gray-400 italic" data-id="element-277">
              Si requieres algún servicio adicional, con gusto te atenderemos.
              El costo será consensuado por ambas partes.
            </p>
          </div>

          {/* Additional Services */}
          <div className="bg-gradient-to-br from-purple-100 to-purple-50 dark:from-purple-900/30 dark:to-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2" data-id="element-278">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-279">
              Servicios Adicionales
            </h3>
            <ul className="space-y-4" data-id="element-280">
              {additionalServices.map((service, index) => <li key={index} className="flex items-start" data-id="element-281">
                  <PlusCircleIcon className="w-6 h-6 text-purple-600 dark:text-purple-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-282" />
                  <span className="text-gray-700 dark:text-gray-300" data-id="element-283">
                    {service}
                  </span>
                </li>)}
            </ul>
            <div className="mt-8 p-4 bg-purple-200 dark:bg-purple-900/50 rounded-lg" data-id="element-284">
              <p className="text-sm text-gray-800 dark:text-gray-200 font-medium" data-id="element-285">
                💡 Estos servicios tienen costos adicionales que se determinarán
                según tus necesidades específicas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}